import React from 'react';
import PropTypes from 'prop-types';
import {Button} from 'react-bootstrap';

const btnStyle = {
  minWidth: '34px',
  height: '34px',
  padding: '0 8px',
  fontSize: '0.85rem',
  lineHeight: 1,
};

const Pagination = ({currentPage, totalPages, setCurrentPage, getPageItems}) => {
  if (totalPages <= 1) return null;

  return (
    <div className="d-flex gap-1 justify-content-center mt-3">
      <Button
        variant="outline-secondary"
        style={btnStyle}
        disabled={currentPage === 1}
        onClick={() => setCurrentPage((p) => p - 1)}
      >
        ‹
      </Button>
      {getPageItems().map((item, i, all) => {
        if (item === '...') {
          const neighbor = all[i - 1] ?? 'start';
          return (
            <Button key={`ellipsis-after-${neighbor}`} variant="outline-secondary" style={btnStyle} disabled>
              …
            </Button>
          );
        }
        return (
          <Button
            key={item}
            variant="outline-secondary"
            style={btnStyle}
            active={item === currentPage}
            disabled={item === currentPage}
            onClick={() => setCurrentPage(item)}
          >
            {item}
          </Button>
        );
      })}
      <Button
        variant="outline-secondary"
        style={btnStyle}
        disabled={currentPage === totalPages}
        onClick={() => setCurrentPage((p) => p + 1)}
      >
        ›
      </Button>
    </div>
  );
};

Pagination.propTypes = {
  currentPage: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  setCurrentPage: PropTypes.func.isRequired,
  getPageItems: PropTypes.func.isRequired,
};

export default Pagination;
